/**
 * This file is simply for bootstrapping all the other modules, and their relevant
 * javascript files. Think of it as a module index for the front-end.
 */

require('./ai-agents/routes.js');
require('./awards/routes.js');
require('./clear/routes.js');
require('./dashboard/routes.js');
require('./entries/routes.js');
require('./entry-form/routes.js');
require('./exports/routes.js');
require('./features/routes.js');
require('./fields/routes.js');
require('./forms/routes.js');
require('./funding/routes.js');
require('./gallery-dashboard/routes.js');
require('./gallery/routes.js');
require('./grant-reports/routes.js');
require('./grants/routes.js');
require('./home/routes.js');
require('./integrations/routes.js');
require('./interface-text/routes.js');
require('./judge-dashboard/routes.js');
require('./judging-dashboard/routes.js');
require('./judging/routes.js');
require('./leaderboard/routes.js');
require('./notifications/routes.js');
require('./orders/routes.js');
require('./panel/routes.js');
require('./payment-methods/routes.js');
require('./payment-schedule-templates/routes.js');
require('./payment-subscriptions/routes.js');
require('./payment/routes.js');
require('./price/routes.js');
require('./provisioning/routes.js');
require('./qualifying/routes.js');
require('./reports/routes.js');
require('./review-flow/routes.js');
require('./role/routes.js');
require('./rounds/routes.js');
require('./score-set/routes.js');
require('./scoring-criteria/routes.js');
require('./seasons/routes.js');
require('./setting/routes.js');
require('./tabs/routes.js');
require('./tags/routes.js');
require('./taxes/routes.js');
require('./theme/routes.js');
require('./tiers/routes.js');
require('./top-pick/routes.js');
require('./users/routes.js');
require('./voting/routes.js');
require('./webhooks/routes.js');
